// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2age9","right":"styles_right__5ZZEY"};